import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';

interface Props {
  loading?: boolean;
  icon: Icons;
  text?: {
    loadingText: string;
    noResultHeadline?: string;
    noResultText: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPreviewPlaceholder.ts',
  props: {
    loading: { type: Boolean },
    icon: null,
    text: { default: () => ({
    loadingText: 'Loading...',
    noResultText: 'No result found',
  }) }
  },
  setup(__props: any) {



return { __sfc: true,CcIcon }
}

})